const POPUP_COOKIE_NAME = "kalevi_popup_closed";

function hasSessionCookie() {
  return document.cookie
    .split(";")
    .some((cookie) => cookie.trim().startsWith(`${POPUP_COOKIE_NAME}=`));
}

function setSessionCookie() {
  const secure = window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${POPUP_COOKIE_NAME}=1; Path=/; SameSite=Lax${secure}`;
}

function initGlobalPopup() {
  const popup = document.querySelector("[data-global-popup]");

  if (!popup || hasSessionCookie()) {
    return;
  }

  const closeButton = popup.querySelector("[data-popup-close]");
  const cta = popup.querySelector("[data-popup-cta]");

  if (!closeButton || typeof popup.showModal !== "function") {
    return;
  }

  const closePopup = () => {
    setSessionCookie();
    popup.close();
  };

  closeButton.addEventListener("click", closePopup);
  cta?.addEventListener("click", closePopup);

  popup.addEventListener("cancel", (event) => {
    event.preventDefault();
    closePopup();
  });

  popup.addEventListener("close", () => {
    document.body.classList.remove("global-popup-open");
  });

  document.body.classList.add("global-popup-open");
  popup.showModal();

  window.requestAnimationFrame(() => {
    popup.focus();
  });
}

export { initGlobalPopup };
